<template>
  <div id="exBasket" class="container">
    <h3 class="stitle mb50">
      체험바구니
      <div class="tit_btnbox">
        <a class="btn_color2" @click="onRemoveCartItem">삭제</a>
        <a class="btn_color2" @click="onRemoveAllCartItems">비우기</a>
      </div>
    </h3>
    <div v-for="group in groupItems" :key="group.key">
      <h4 class="checkbox">
        <input type="checkbox" name="checkGroup" :id="group.key" :value="group.key" v-model="checkGroup" />
        <label :for="group.key">체험일 : {{ group.expVisitNm }}</label>
      </h4>
      <ul class="basketList">
        <CartListItem v-for="cartItem in group.items" :key="cartItem.cartNo" :cartItem="cartItem" />
      </ul>
    </div>
    <p class="totalPriceTit">
      선택 :
      <span class="has-text-weight-bold">{{ checkedItems.length }}</span>
    </p>
    <div class="totalPriceBox mb50">
      <ul class="div3">
        <li>
          <strong>총상품금액</strong>
          <span>
            <i class="fs_big tcolor1">{{ _priceFormat(originPrice) }}</i>
            원
          </span>
        </li>
        <li class="price_icon1">
          <strong>총할인금액</strong>
          <span>
            <i class="fs_big">{{ _priceFormat(dcPrice) }}</i>
          </span>
        </li>
        <li class="price_icon3">
          <strong>총결제금액</strong>
          <span>
            <i class="fs_big">{{ _priceFormat(totPrice) }}</i>
          </span>
        </li>
      </ul>
    </div>
    <p v-if="groupItems.length === 0" class="cart-empty-text has-text-centered">체험바구니가 비어있습니다</p>
    <div class="btn_wrap mt30" v-if="isInviteItems">
      <a class="btn btn_bg color" @click="onPledgeClick">예약하기</a>
    </div>
    <div class="btn_wrap mt30" v-else>
      <a class="btn btn_bg line" v-if="currentRouteType === 'grp'" @click="onPledgeClick">확약서 예약하기</a>
      <a class="btn btn_bg color1" style="background-color: #555" @click="onMoreClick">추가예약</a>
      <a class="btn btn_bg color" @click="onPaymentClick">결제하기</a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { orderValid, orderPledge } from '@/utils/reserve';
import { uniq } from 'lodash';
import CartListItem from './CartListItem';

export default {
  name: 'CartList',
  components: {
    CartListItem,
  },
  data() {
    return {
      checkGroup: [],
    };
  },
  computed: {
    ...mapGetters(['checkedItems', 'groupItems', 'cartTotal', 'cartQuantity']),
    //임시 가격들 서버에서 계산해서 담아오면 됨.
    originPrice() {
      return this.checkedItems.reduce((a, cartItem) => {
        return a + cartItem.originPrice;
      }, 0);
      // return this.checkedItems.reduce((a, cartItem) => {
      //   if (cartItem.pcntYn === 'Y') {
      //     return a + cartItem.price;
      //   } else {
      //     const { includeList = [], leaderList = [] } = cartItem;
      //     let price = includeList.reduce((a, p) => a + p.orgPrice * p.pcnt, 0) + leaderList.reduce((a, p) => a + p.orgPrice * p.pcnt, 0);
      //     return a + price;
      //   }
      // }, 0);
    },
    dcPrice() {
      return this.originPrice - this.totPrice;
      // return this.checkedItems.reduce((a, cartItem) => {
      //   const { includeList = [], leaderList = [] } = cartItem;
      //   let price =
      //     includeList
      //       .filter((e) => e.pesnDivCd !== '01')
      //       .reduce((a, p) => {
      //         return a + p.orgPrice * 0.5;
      //       }, 0) +
      //     leaderList
      //       .filter((e) => e.pesnDivCd !== '01')
      //       .reduce((a, p) => {
      //         return a + p.orgPrice * 0.5;
      //       }, 0);
      //   return a + price;
      // }, 0);
    },
    totPrice() {
      return this.checkedItems.reduce((a, cartItem) => {
        return a + cartItem.saleAmt;
      }, 0);
      // return this.originPrice - this.dcPrice;
    },
    isGroupItems() {
      return this.checkedItems.length > 0 && this.checkedItems.every((e) => e.groupPersDiv === '01');
    },
    isInviteItems() {
      return this.checkedItems.length > 0 && this.checkedItems.every((e) => e.inviteYn === 'Y');
    },
  },
  watch: {
    checkGroup(to, from) {
      if (to.length > from.length) {
        const added = to.find((t) => !from.find((f) => f === t));
        this.changeItemCheck({ target: added, value: true });
      } else {
        const remove = from.find((f) => !to.find((t) => t === f));
        this.changeItemCheck({ target: remove, value: false });
      }
    },
    $route(to, from) {
      this.$store.dispatch('getCartItems', this.groupPersDiv);
    },
  },
  created() {
    this.$store.dispatch('getCartItems', this.groupPersDiv);
  },
  methods: {
    ...mapActions(['removeAllCartItems', 'removeCartItem', 'changeItemCheck', 'updateBookingList']),
    onRemoveCartItem() {
      this.removeCartItem(this.groupPersDiv);
    },
    onRemoveAllCartItems() {
      this.removeAllCartItems(this.groupPersDiv);
    },
    onMoreClick() {
      this.$router.push('/' + this.currentRouteType);
    },
    
    onPledgeClick() {
      const onJobProd = this.checkedItems.find((e) => e.pdDiv === '20');
      /*
      if (onJobProd) {
        alert(`ONJOB 상품(${onJobProd.mrktnPdNm})은 확약서 예약을 할 수 없습니다. 결제하기로 진행해 주세요.`);
        return false;
      }
      */
      if (this.isInviteItems) {
        this.toPayment('pledgeCmpl', '확약');
      } else {
        this.toPayment('pledge', '확약');
      }
    },
    onPaymentClick() {
      this.toPayment('normal', '결제');
    },
    async toPayment(mode, name) {
      // 확약서 전용 상품 확인
      if (!mode.includes('pledge')) {
        const onlyPledegeList = ['724', '898', '916']; // 확약서예약 만 사용할 상품번호 추가
        let chkPledege = {};
        onlyPledegeList.every((item) => {
          if (chkPledege !== 'undifined') chkPledege = this.checkedItems.find((e) => e.mrktnPdNo.toString() === item);
        });
        if (chkPledege) {
          alert(`메카이브 상품(${chkPledege.mrktnPdNm})은 결제 예약을 할 수 없습니다. 확약서 예약하기로 진행해 주세요.`);
          return false;
        }
      }

      const expVisitRvdtList = uniq(this.checkedItems.map((e) => e.expVisitRvdt));
      if (this.checkedItems.length === 0) {
        alert('선택된 상품이 없습니다.');
      } else if (expVisitRvdtList.length > 1) {
        alert('같은 체험일의 상품만 함께 ' + name + ' 할 수 있습니다.');
      } else if (!(await orderValid([...this.checkedItems]))) {
      } else if (!(await orderPledge([...this.checkedItems]))) {
        // 가예약(확약서) 예약 100명 초과 2건 초과 제한
      } else {
        this.updateBookingList({ bookingList: [...this.checkedItems], mode: mode });
        this.$router.push('/' + this.currentRouteType + '/payment');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
